import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useCounter from '../hooks/useCounter';

function Home() {
  const navigate = useNavigate();
  const [ticketNumber, setTicketNumber] = useState('');
  
  // Initialize counters with the same options as the About page
  useCounter('.timer', {
    threshold: 0.5,
    rootMargin: '0px'
  });

  const handleSearch = (e) => {
    e.preventDefault();
    if (ticketNumber.trim()) {
      navigate(`/tracking?ticket=${ticketNumber.trim()}`);
    }
  };
  
  return (
    <>
      <section className="modern-banner-2">
        <div className="container">
          <div className="row banner-bg">
            <div className="col-xl-6 col-lg-8">
              <div className="banner-content">
                <h2>The Key Valet Service</h2>
                {/* <h3>The Key to Smooth Parking</h3> */}
                <p>We provide trusted and organized valet parking for hotels, events and businesses across Qatar.</p>
                {/* <a className="button extra-large black_2 mt-0" href="#request_car">Track Vehicle</a> */}
              </div>
            </div>
            <div className="col-xl-6 col-lg-4">
              <div className="banner-car">
                <img src="images/modern-home/car-image-new.png" />
              </div>
            </div>
          </div>
      </div></section>
      <section className="theme-bg car-directory-section" id="request_car">
        <div className="section-overlay" data-overlay-opacity="1" style={{
          backgroundImage: 'url(images/modern-home/bg/section-bg-pattern-2.png)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}></div>
          <div className="container">
            <div className="row">
              <div className="col-md-12">                  
                <div className="car-directory-banner car-directory-banner-new widget-light">              
                    <div className="search-tab">
                      {/* <div id="search-tabs">
                        <div className="tabs-header">
                          <h6>Request Your Vehicle </h6>
                        </div>
                        <div className="tab-content" id="myTabContent02">
                            <div className="tab-pane fade show active" id="all-cars" role="tabpanel" aria-labelledby="all-cars-tab">
                              <div className="row">
                                <div className="col-xl-10 col-lg-9 col-md-12">
                                  <div className="row">
                                    <div className="col-xl-12 col-lg-3 col-md-6">
                                      <div className="form-group">
                                        <input 
                                        id="name01" 
                                        type="text" 
                                        placeholder="Plate or Ticket Number*" 
                                        className="form-control placeholder" 
                                        name="name"
                                        value={ticketNumber}
                                        onChange={(e) => setTicketNumber(e.target.value)}
                                      />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              <div className="col-xl-2 col-lg-3 col-md-12">
                                <div className="d-grid">
                                  <button 
                                    className="button red" 
                                    type="button"
                                    onClick={handleSearch}
                                  >
                                    Search
                                  </button>
                                </div>
                              </div>
                            </div>
                        </div>
                      </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
      </div>
    </section>
    <section className="welcome-block objects-car page-section-ptb white-bg">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
              <div className="section-title">
                <h2>The Key Valet</h2>
                <div className="separator"></div>
                <p>The Key Valet Parking devliveres premium, efficient valet services, ensuring smooth arrivals and departures at luxury hotels, events, Malls and exclusive venues. Our professional team provides secure, well-managed parking solutions for businesses and organizers who demand reliability and service excellence. </p> </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="feature-box text-center">
              <div className="icon">
                <i className="glyph-icon flaticon-steering-wheel"></i>
              </div>
              <div className="content">
                <h6>VIP Service</h6>
                <p>Priority parking and personalized handling for high-profile guests and clients.</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="feature-box text-center">
              <div className="icon">
                <i className="glyph-icon flaticon-padlock"></i>
              </div>
              <div className="content">
                <h6>Safe Parking</h6>
                <p>Vehicles are parked in secure, monitored areas with full accountability.</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="feature-box text-center">
              <div className="icon">
                <i className="glyph-icon flaticon-mechanic"></i>
              </div>
              <div className="content">
                <h6>Trained Staff</h6>
                <p>Professionally dressed and well-trained team ensures smooth guest experience.</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="feature-box text-center">
              <div className="icon">
                <i className="glyph-icon flaticon-clock"></i>
              </div>
              <div className="content">
                <h6>Time Saving</h6>
                <p>No more searching for parking—drop your keys and we handle the rest.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="counter counter-style-2 my-0 my-sm-4">
      <div className="container">
        <div className="row theme-bg counter-box m-0">
        <div className="col-lg-3 col-sm-6 item">
          <div className="counter-block text-start">
            <div className="separator"></div>
              <div className="info">
                <h6 className="text-white">Parked</h6>
                <i className="glyph-icon flaticon-beetle"></i>
                <b className="timer text-white" data-to="561" data-speed="3000"></b>
              </div>
            </div>
        </div>
        <div className="col-lg-3 col-sm-6 item">
          <div className="counter-block text-start">
            <div className="separator"></div>
            <div className="info">
              <h6 className="text-white">Rated</h6>
              <i className="glyph-icon flaticon-interface"></i>
              <b className="timer text-white" data-to="856" data-speed="3000"></b>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 item">
          <div className="counter-block text-start mb-4 mb-sm-0">
            <div className="separator"></div>
            <div className="info">
              <h6 className="text-white">Trusted</h6>
              <i className="glyph-icon flaticon-circle"></i>
              <b className="timer text-white" data-to="789" data-speed="3000"></b>
            </div>
          </div>
          </div>
          <div className="col-lg-3 col-sm-6 item">
          <div className="counter-block text-start mb-0">
            <div className="separator"></div>
            <div className="info">
              <h6 className="text-white">Served</h6>
              <i className="glyph-icon flaticon-cup"></i>
              <b className="timer text-white" data-to="356" data-speed="3000"></b>
            </div>
            </div>
        </div>
        </div>
      </div>
    </section>
    <section className="feature-car-area page-section-ptb">
      <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-8 col-md-10">
        <div className="section-title-new text-center">
          <h2 className="main-title">How It Works</h2>
          <p>From drop-off to return, each step is managed with care, clarity and attention to detail—ensuring a smooth experience from start to finish.</p>
        </div>
        </div>
      </div>
      <div className="row align-items-center">
        <div className="col-lg-4 col-sm-6 pe-lg-5 mb-5 mb-sm-0">
          <div className="cdhl-infobox style-1 icon-shape-default">
            <div className="infobox-icon icon-type-default">
              <i className="fa-solid fa-square-parking"></i>
            </div>
            <div className="infobox-content">
              <h5 className="infobox-title">Choose Parking Type</h5>
              <div className="infobox-description">Guest selects between VIP or Normal parking on arrival at the location.</div>
            </div>
          </div>
          <div className="cdhl-infobox style-1 icon-shape-default">
            <div className="infobox-icon icon-type-default">
              <i className="fa-solid fa-phone"></i>
            </div>
            <div className="infobox-content">
              <h5 className="infobox-title">Share Mobile Number</h5>
              <div className="infobox-description">Phone number is recorded and vehicle is safely moved to parking.</div>
            </div>
          </div>
          <div className="cdhl-infobox style-1 icon-shape-default">
            <div className="infobox-icon icon-type-default">
              <i className="fa-solid fa-qrcode"></i>
            </div>
            <div className="infobox-content">
              <h5 className="infobox-title">Request via QR or Link</h5>
              <div className="infobox-description">Customer can request the car using a QR or the SMS link provided.</div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center d-none d-lg-block">
            <img className="img-fluid" src="images/modern-home/car-top.png" alt="#" />
        </div>
        <div className="col-lg-4 col-sm-6 ps-lg-5">
          <div className="cdhl-infobox style-1 icon-shape-default">
            <div className="infobox-icon icon-type-default">
              <i className="fa-solid fa-credit-card"></i>
            </div>
            <div className="infobox-content">
              <h5 className="infobox-title">Make Payment Online</h5>
              <div className="infobox-description">Secure payment is completed through the link sent on mobile.</div>
            </div>
          </div>
          <div className="cdhl-infobox style-1 icon-shape-default">
            <div className="infobox-icon icon-type-default">
              <i className="fa-solid fa-car-side"></i>
            </div>
            <div className="infobox-content">
              <h5 className="infobox-title">Car Brought to Exit</h5>
              <div className="infobox-description">Driver brings the vehicle to the exit point shared by the customer.</div>
            </div>
          </div>
          <div className="cdhl-infobox style-1 icon-shape-default">
            <div className="infobox-icon icon-type-default">
              <i className="fa-solid fa-check-double"></i>
            </div>
            <div className="infobox-content">
              <h5 className="infobox-title">Quick and Organized</h5>
              <div className="infobox-description">The entire process is handled smoothly with proper coordination.</div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
    <section className="our-partners section-pb">
    <div className="container">
        <div className="row">
        <div className="col-md-12">
          <div className="divider-separator mt-5">
              <span className="separator-1">
                <span className="separator-line"></span>
              </span>
              <h4 className="separator-title">Our Partners</h4>
              <span className="separator-1">
                <span className="separator-line"></span>
              </span>
            </div>
        </div>
        </div>
      <div className="row">
        <div className="col-lg-12 col-md-12">
          <div className="owl-carousel our-clients-carousel" data-nav-dots="false" data-items="5" data-md-items="5" data-sm-items="3" data-xs-items="2" data-space="10">
              <div className="item">
                <img className="img-fluid center-block" src="images/clients/01.png" alt="" />
              </div>
              <div className="item">
                <img className="img-fluid center-block" src="images/clients/02.png" alt="" />
              </div>
              <div className="item">
                <img className="img-fluid center-block" src="images/clients/03.png" alt="" />
              </div>
              <div className="item">
                <img className="img-fluid center-block" src="images/clients/04.png" alt="" />
              </div>
              <div className="item">
                <img className="img-fluid center-block" src="images/clients/05.png" alt="" />
              </div>
              <div className="item">
                <img className="img-fluid center-block" src="images/clients/06.png" alt="" />
              </div>
              <div className="item">
                <img className="img-fluid center-block" src="images/clients/07.png" alt="" />
              </div>
          </div>
        </div>
      </div>
      </div>
    </section>
      <section className="actionbox_section">
        <div className="container">
          <div className="row theme-bg align-items-center mx-0">
            <div className="col-lg-4">
              <h4 className="actionbox-title">Why Choose Our Services</h4>
            </div>
            <div className="col-lg-4 justify-content-lg-center d-flex my-4 my-lg-0">
              <a href="tel:+97433777441" className="actionbox-infobox-icon">
                <i className="fas fa-phone"></i>
              </a>
            </div>
            <div className="col-lg-4">
              <div className="text-lg-end">
                <div className="actionbox-infobox-description">Get Professional Help</div>
                <h5 className="actionbox-infobox-title">+974 3377 7441</h5>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-ptb why-choose-services_section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="car-services">
                <div className="section-title-new">
                <h2 className="main-title text-white">What Our Guests Experience</h2>
                <p className="text-white">From the first step to the final handover, we focus on delivering a smooth, respectful and professional experience that leaves a lasting impression.</p>
              </div>
                <div className="infoboxs">
                  <div className="cdhl-infobox style-2 icon-shape-round cdhl-infobox-light">
                    <div className="infobox-icon icon-type-flat">
                      <i className="fa-solid fa-handshake"></i>
                    </div>
                    <div className="infobox-content">
                      <h5 className="infobox-title">Polite Greeting</h5>
                      <div className="infobox-description">Every guest is welcomed with respect, reflecting well on your venue or event.</div>
                    </div>
                  </div>
                  <div className="cdhl-infobox style-2 icon-shape-round cdhl-infobox-light">
                    <div className="infobox-icon icon-type-flat">
                      <i className="fa-solid fa-car-on"></i>
                    </div>
                    <div className="infobox-content">
                      <h5 className="infobox-title">Prompt Delivery</h5>
                      <div className="infobox-description">Vehicles are returned without delay—timing and exit or gate followed as requested.</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 section-bg-image justify-content-center justify-content-lg-end d-flex">
              <div className="video-box">
                <div className="video-info">
                  <a className="popup-youtube" href="https://www.youtube.com/watch?v=zwHwiytn5U8"><i className="fas fa-play"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;